import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Conversation } from "../components/common/ConversationItem";

interface ConversationFilters {
  status: "all" | "draft" | "closed" | "solved" | "open";
  type: "all" | "circle_bot" | "live_chat" | "email";
}

interface ApiResponse {
  conversations: Conversation[];
  error?: string;
}

export const useListConversations = ({ type, status }: ConversationFilters) => {
  const listConversations = (): Promise<ApiResponse> =>
    reactQueryGet(
      internalApi.helpWidget.listConversations({
        conversationFilters: {
          channel_type: type,
          status,
        },
      }),
    );

  return useQuery(
    ["help-widget", "conversations", type, status],
    listConversations,
  );
};
